import { connect } from 'react-redux';
import ContractAssets from './contractAssets';
import { bindActionCreators } from 'redux';
import {
  getgatesByContratctId,
} from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
    siteGatesData: state.siteListingReducer.contractGates
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getgatesByContratctId
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ContractAssets);
